import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Modal, ModalHeader, ModalBody, P, H3, FlexRow } from '@contently/toolkit';

import AdditionalInfoForm from './AdditionalInfoForm';
import useLocalStorage from '../utils/hooks/useLocalStorage';
import GA from '../utils/GoogleAnalytics';
import CallToAction from './CallToAction';

const StyledModalWrapper = styled('div')`
  width: 75%;
  margin: 8% auto;
`;

const StyledModalBody = styled(ModalBody)`
  padding: 0;
`;

const StyledModalHeader = styled(ModalHeader)`
  font-size: 24px;
  font-weight: 400;
  margin: 7% 0 10px 0;
  padding: 0;
`;

const StyledP = styled(P)`
  font-size: 0.8125rem;
  font-weight: 300;
  line-height: 1.5;
`;

const AdditionalInfoModal = props => {
  const { isOpen, onClose, onInfoFormSubmit } = props;
  const [totalSearches] = useLocalStorage('totalSearches', 5);

  useEffect(() => {
    if (isOpen && GA.trackingEnabled) {
      GA.client.modalview('AdditionalInfoModal');
    }
  }, [isOpen]);

  let modalHeaderContent = 'Let’s get to know each other.';
  let modalBodyContent = (
    <>
      <FlexRow margin={{ bottom: 'medium' }}>
        <StyledP>
          Tell us a bit more about your content needs and we’ll let you search the database three
          more times!
        </StyledP>
      </FlexRow>
      <AdditionalInfoForm onInfoFormSubmit={onInfoFormSubmit} />
    </>
  );
  if (totalSearches === 8) {
    modalHeaderContent = 'Wow! That was your last free search!';
    modalBodyContent = (
      <H3>
        You’re clearly an ambitious content marketer on the hunt for creatives who can help you
        bring your vision to life.
        <FlexRow margin={{ vertical: 'small' }}>
          <CallToAction />
        </FlexRow>
      </H3>
    );
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <StyledModalWrapper>
        <StyledModalHeader>{modalHeaderContent}</StyledModalHeader>
        <StyledModalBody>{modalBodyContent}</StyledModalBody>
      </StyledModalWrapper>
    </Modal>
  );
};

AdditionalInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onInfoFormSubmit: PropTypes.func.isRequired
};

export default AdditionalInfoModal;
